import { divisionId, schemaId, teamCategory, teamName } from 'cpool-schemas';
import { z } from 'zod';

export const TeamsTableDefinitionZod = z.object({
    category: teamCategory,
    deactivated: z.boolean(),
    divisionAggregateId: schemaId,
    // 6 character division handle, kept alongside the aggregateId for handle-based lookups
    divisionId,
    id: schemaId,
    leaderId: schemaId.nullable(),
    // mirrors Users.teamId so every team event touches this row and position reads stay consistent
    memberIds: z.array(schemaId),
    name: teamName,
});

export type TeamsTableSchema = z.infer<typeof TeamsTableDefinitionZod>;
